<template>
  <div class="server-summary-panel flex-column space-between" :class="isMobile ? 'mobile': undefined">
    <div>
      <div class="tags flex-row" v-if="server.tags.length">
        <!-- <template v-for="(tag, index) in server.tags">
          <span :key="index">{{tag}}</span>
        </template> -->
        <!-- <Tag v-for="(tag, index) in server.tags" :name="tag" v-bind:key="tag" :class="getLRC(index, server.tags)"/> -->
      </div>
      <div class="server-summary flex-column">
        <div class="cpu nowrap">
          <!-- <template v-if="server.cpuNum > 1">{{server.cpuNum}}x </template>{{server.cpu.textname}} -->
          {{server.cpu.family}}
        </div>
        <div>
          <template v-if="server.cpuNum > 1">{{server.cpuNum}}x </template>{{server.cpu.textname}}
        </div>
        <div class="sep"/>
        <div>
          {{server.cpu.freq}} - {{server.cpu.freqTurbo}}GHz
        </div>
        <div class="sep"/>
        <div>
          {{server.cpuNum * server.cpu.cores}} cores / {{server.cpuNum * server.cpu.threads}} threads
        </div>
        <div class="sep"/>
        <div>
          {{server.ram}}GB RAM
        </div>
        <div class="sep" v-if="server.gpus.length"/>
        <template v-for="gpu in server.gpus">
          <div :key="gpu.index">
            {{gpu.textname}} GPU
          </div>
        </template>
        <div class="sep" v-if="server.disks.length"/>
        <template v-for="disk in server.disks">
          <div :key="disk.index">
            {{disk.capacity}}GB {{$t("disk_" + disk.interface)}} {{disk.type.toUpperCase()}}
          </div>
        </template>
      </div>
    </div>
    <div class="price-cont">
      <div class="item flex-row value">{{server.price}} ₽/мес</div>
      <div class="item flex-row" v-if="hasOrderListener">
        <BorderlessButton class="btn" border="blue" @click="order">{{$t("order")}}</BorderlessButton>
      </div>
      <div class="item flex-row" v-if="hasRemoveListener">
        <BorderlessButton class="btn" border="transparent" @click="remove">{{$t("remove")}}</BorderlessButton>
      </div>
    </div>
  </div>
</template>

<script>
//import Tag from "@/components/Tag";
import BorderlessButton from "@/components/BorderlessButton";

export default {
  name: 'ServerSummary',
  components: {
    BorderlessButton,
    //Tag,
  },
  props: {
    server: Object,
  },
  data: function() {
    return {
      isMobile: undefined,
    }
  },
  watch: {
    '$layout.isMobile'(value) {
      this.isMobile = value;
    },
  },
  created() {
    this.isMobile = this.$layout.isMobile;
  },
  computed:{
    hasOrderListener() {
      return this.$listeners && this.$listeners.order;
    },
    hasRemoveListener() {
      return this.$listeners && this.$listeners.remove;
    }
  },
  methods: {
    order: function() {
      this.$emit('order', this.server);
    },
    remove: function() {
      this.$emit('remove', this.server);
    },
    getLRC: function(index, list) {
      if (list.length == 1) return undefined;
      if (index == 0) return 'left';
      if (index == list.length -1) return 'right';
      return 'center';
    },
  }
}
</script>

<style scoped lang="scss">

.server-summary-panel.mobile {
  //width: min(400px, calc(100vw - 60px)); // 2*$side-gap-small
  width: min(400px, calc(100vw - 80px)); // UX: extra 20px so that users can see next tile
  //height: 425px;
  .server-summary {
    gap: 10px;
  }
}

.server-summary-panel {
  color: $color-1;
  padding: 20px;
  border: 1px solid $color-2-2;
  border-radius: 5px;
  flex: 1;
  height: $server-details-h;
  box-sizing: border-box;
  //max-width: 325px;

  .tags {
    margin: 0;
    padding: 0;
    margin-bottom: 5px;

    //border: 1px solid red;
    gap: 5px;
    font-size: 15px;
    font-weight: bold;
    font-style: italic;
  }

  .server-summary {
    gap: 15px;

    .cpu {
      font-size: 22px;
      font-weight: bold;
      margin-bottom: 20px;
      color: $color-1-active;
    }

    .sep {
      padding: 0;
      height: 1px;
      max-height: 1px;
      background: linear-gradient(90deg, $color-2-1, $color-2-2);
      //border-bottom: 1px solid red;
    }
  }

  .price-cont {

    .value {
      font-size: 20px;
      font-weight: 800;
      color: $color-1-active;
      margin-bottom: 10px;
    }

    .item {
      justify-content: center;

      .btn {
        flex: 1;
      }
    }
  }
}

</style>
